import React from 'react';
import { Button } from './ui/button';
import { Mail, Clock } from 'lucide-react';

// Ícone do WhatsApp (SVG oficial simplificado)
const WhatsAppIcon = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.88 11.88 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 0 0-3.48-8.413z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-text">VAGA BLINDADA ROV</div>
            </div>
            <p className="body-medium">
              O curso mais completo para conquistar sua vaga de trainee ROV no mercado offshore.
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={16} />
                <span className="body-small">contato@vagablindadarov.com</span>
              </div>
              <a
                href="https://wa.me/5522988196922"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-contact-link"
                aria-label="Fale conosco no WhatsApp"
                title="Fale conosco no WhatsApp"
              >
                <span className="whatsapp-icon-circle">
                  <WhatsAppIcon size={20} />
                </span>
                <span className="body-small">Fale conosco no WhatsApp</span>
              </a>
              <div className="contact-item">
                <Clock size={16} />
                <span className="body-small">Atendimento: 9h às 18h</span>
              </div>
            </div>
          </div>
          
          <div className="footer-links">
            <div>
              <h4 className="footer-title heading-3">Links Rápidos</h4>
              <ul className="footer-list">
                <li><a href="#benefits" className="footer-link">Benefícios</a></li>
                <li><a href="#content" className="footer-link">Conteúdo</a></li>
                <li><a href="#instructor" className="footer-link">Instrutor</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom-content">
          <div className="footer-legal">
            <span className="caption">© 2024 VAGA BLINDADA ROV. Todos os direitos reservados.</span>
          </div>
          <div className="footer-legal">
            <a href="#" className="footer-link caption">Política de Privacidade</a>
            <a href="#" className="footer-link caption">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;